module.exports = __webpack_public_path__ + "img/logo-row.4de0cfc8.png";